import { Box, ButtonBase, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { LogoWhite } from 'modules/layout/components/Logo/logo-white';
import { SonicLogo } from 'modules/layout/components/Logo';
import { default as RightLogoIcon } from './assets/right-logo.svg?react';

import { Connect } from '../../../Connect';

interface HeaderProps {
  hasConnect?: boolean;
}

export function Header({ hasConnect = true }: HeaderProps): JSX.Element {
  return (
    <Box
      component="header"
      sx={{
        padding: theme => theme.spacing(2.5, 0),
      }}
    >
      <Container maxWidth={false}>
        <Stack
          justifyContent="space-between"
          alignItems="center"
          flexDirection="row"
          sx={{ width: '100%', gap: { xs: 1, md: 2 } }}
        >
          <ButtonBase to="/" component={Link}>
            <Stack gap={1.5} flexDirection="row" alignItems="center">
              <Box
                component={LogoWhite}
                sx={{
                  height: {
                    xs: 22,
                    md: 28,
                  },
                }}
              />

              <Box
                component={SonicLogo}
                sx={{
                  height: {
                    xs: 28,
                    md: 36,
                  },
                  width: {
                    xs: 76,
                    md: 91,
                  },
                }}
              />
            </Stack>
          </ButtonBase>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ width: '100%', gap: { xs: 1, md: 3 } }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              gap={1.5}
              sx={{ display: { xs: 'none', md: 'flex' } }}
            >
              <Typography color="text.secondary" variant="body2">
                Powered by:
              </Typography>
              <Box component={RightLogoIcon} sx={{ height: 16 }} />
            </Stack>

            {hasConnect && <Connect />}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
